import Role from '@/enums/Role';
import type { SharedData } from '@/types';
import { usePage } from '@inertiajs/vue3';

export function useRoles() {
    const page = usePage<SharedData>();

    const hasRole = (role: Role): boolean => {
        return page.props.auth.user.roles.includes(role);
    };

    const hasAnyRole = (roles: Role[]): boolean => {
        return roles.some((role) => hasRole(role));
    };

    return {
        hasRole,
        hasAnyRole,
    };
}
